<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      {{modalData.title}}
    </div>
    <div class="inputs">
      <span>Pitanje:</span>
      <textarea class="single-input" rows="4" v-model="question"></textarea>
    </div>
    <div class="inputs">
      <span>Odgovor:</span>
      <textarea class="single-input" rows="4" v-model="answer"></textarea>
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn">
        ok
      </div>
      <div @click="closeModal()" class="btn">
        odustani
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'editFaqLocale',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      question: null,
      answer: null
    }
  },
  mounted () {
    let params = {
      id: this.modalData.faq.id
    }
    api.getFaqLocale(params).then(res => {
      if (res.data.data.length > 0) {
        for (let i = 0; i < res.data.data.length; i++) {
          console.log(res.data.data[i]);
          if (res.data.data[i].locale === this.$route.params.lang) {
            this.question = res.data.data[i].question
            this.answer = res.data.data[i].answer
          }
        }
      }
    })
  },
  methods: {
    ok () {
      let params = {
        question: this.question,
        answer: this.answer,
        question_locale: this.$route.params.lang
      }
      this.modalData.ok(params)
      eventBus.$emit('closeModal')
    },
    closeModal () {
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 10px 0px;
      width: 100%;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
